import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#FFFFFF',
    color: 'black',
  },
  container: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    letterSpacing: '0.12em',
    fontWeight: 700,
    textTransform: 'uppercase',
    fontFamily: theme.typography.overline.fontFamily,
    display: 'block',
    marginBottom: theme.spacing(1),
  },
  headline: {
    ...theme.typography.h3,
    color: theme.palette.text.primary,
    marginTop: 0,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.75rem',
      lineHeight: 1.2,
    },
  },
  personaTabsSection: {
    width: '100%',
  },
  personaTabsRoot: {
    '&&': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  },
  tabsDivider: {
    border: 0,
    borderTop: `1px solid ${theme.palette.grey.light}`,
    margin: 0,
    marginBottom: theme.spacing(3),
  },
  emptyPersonaMessage: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
  },
  experienceWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  experienceSectionHeading: {
    gridColumn: '1 / -1',
    marginBottom: theme.spacing(0.5),
  },
  experienceSectionHeadingSpaced: {
    marginTop: theme.spacing(2),
  },
  experienceSectionLabel: {
    /**
     * Canonical coach-profile eyebrow type system: overline font
     * family, 12px, 700, `0.12em` tracking, uppercase. Uses
     * `text.secondary` here because this label is a subdued in-card
     * subsection divider rather than a primary section eyebrow.
     */
    fontFamily: theme.typography.overline.fontFamily,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
  },
  experienceType: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: theme.spacing(4),
    rowGap: theme.spacing(0.5),
    width: '100%',
    maxWidth: 960,
    marginLeft: 'auto',
    marginRight: 'auto',

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      columnGap: 0,
    },
  },
  experienceEntry: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
  },
  checkIcon: {
    fontSize: 18,
    width: 18,
    height: 18,
    flexShrink: 0,
    marginTop: 2,
  },
  experienceName: {
    fontSize: '1rem',
    lineHeight: 1.45,
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
}))

export default useStyles
